
    <div class="device-range-widget" *ngIf="!entity">
      <widget-spinner></widget-spinner>
    </div>
    <ng-container *ngIf="entity">
      <ng-container [ngSwitch]="layout">
        <div class="device-range-widget row" *ngSwitchCase="'table'">
          <div *ngIf="options['index'] % 35 == 0" class="col-12">
            <div class="row" *ngIf="options['index'] != 0">
              <div class="col mt-3"><hr /></div>
            </div>

            <div
              class="row"
              [ngClass]="{
                'div-table-tr': ((options['index'] || 0) % 36) % 2 == 1,
                'div-table-tr-alt': ((options['index'] || 0) % 36) % 2 == 0
              }"
            >
              <div class="col-2">Id</div>
              <div class="col-3">Name</div>
              <div class="col-2">Range</div>
              <div class="col">
                <div class="row gx-2">
                  <div class="col-4">Series</div>
                  <div class="col-4">Man</div>
                  <div class="col-4">Batch</div>
                </div>
              </div>
              <div class="col-2">Sensor Type</div>
            </div>
          </div>

          <div
            class="col-12"
            [ngClass]="{
              'div-table-tr': (((options['index'] || 0) + 1) % 36) % 2 == 1,
              'div-table-tr-alt': (((options['index'] || 0) + 1) % 36) % 2 == 0
            }"
          >
            <div class="row align-items-center">
              <div class="col-2">
                <a class="text-primary" href="#" (click)="sendShowEntry($event, entity)"> #{{ entity.identifier }} </a>
              </div>
              <div class="col-3">
                <b>{{ entity.name || "?" }}</b> -
                <span>{{ entity.description || "?" }}</span>
              </div>
              <div class="col-2">
                <span class="float-left">
                  (<b>{{ entity.range_start || "?" }}</b> ...
                  <b>{{ entity.range_end || "?" }}</b
                  >)
                </span>
                <span class="float-right">
                  <b>{{ entity.cover }}</b> Units
                </span>
              </div>
              <div class="col">
                <div class="row g-2">
                  <div class="col">{{ entity.range_series || "?" }}</div>
                  <div class="col">{{ entity.manufacturer || "?" }}</div>
                  <div class="col">{{ entity.batch || "?" }}</div>
                </div>
              </div>
              <div class="col-2">
                <a
                  class="text-dark"
                  href="#"
                  (click)="
                    showDeviceTypeModal(
                      deviceTypeTemplate,
                      entity._sensor_type_id,
                      $event
                    );
                    $event.stopPropagation()
                  "
                >
                  #{{ entity.device_type }}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="device-range-widget" *ngSwitchCase="'shadowbox'">
          <div *ngIf="options?.edit; else viewMode" class="container-fluid p-3">
            <!-- Common validation message -->
            <div *ngIf="entity?.validation?.messages['common']" class="mb-3">
              <div class="alert alert-warning alert-dismissible fade show">
                {{ entity?.validation?.messages["common"] }}
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
            </div>

            <!-- Identifier (readonly) -->
            <div class="d-flex align-items-center mb-3">
              <label class="form-label mb-0 me-2 font-weight-bold"
                >Identifier:
              </label>
              <span class="font-weight-bold">{{
                entity.identifier || "new"
              }}</span>
            </div>

            <!-- Name field -->
            <div class="mb-3">
              <label class="form-label font-weight-bold">
                <span
                  *ngIf="entity?.validation?.messages['name']"
                  class="text-danger me-2"
                >
                  <i class="fas fa-exclamation-circle"></i>
                </span>
                Name
              </label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="entity.name"
                (ngModelChange)="recordChange()"
                [class.is-invalid]="entity?.validation?.messages['name']"
              />
              <div
                *ngIf="entity?.validation?.messages['name']"
                class="invalid-feedback"
              >
                {{ entity?.validation?.messages["name"] }}
              </div>
            </div>

            <!-- Description field -->
            <div class="mb-3">
              <label class="form-label font-weight-bold">
                <span
                  *ngIf="entity?.validation?.messages['description']"
                  class="text-danger me-2"
                >
                  <i class="fas fa-exclamation-circle"></i>
                </span>
                Description
              </label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="entity.description"
                (ngModelChange)="recordChange()"
                [class.is-invalid]="entity?.validation?.messages['description']"
              />
              <div
                *ngIf="entity?.validation?.messages['description']"
                class="invalid-feedback"
              >
                {{ entity?.validation?.messages["description"] }}
              </div>
            </div>

            <!-- Range fields -->
            <div class="row g-3 mb-3">
              <div class="col-md-6">
                <label class="form-label font-weight-bold">
                  <span
                    *ngIf="entity?.validation?.messages['range_start']"
                    class="text-danger me-2"
                  >
                    <i class="fas fa-exclamation-circle"></i>
                  </span>
                  Range Start
                </label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="entity.range_start"
                  (ngModelChange)="recordChange()"
                  [class.is-invalid]="
                    entity?.validation?.messages['range_start']
                  "
                />
                <div
                  *ngIf="entity?.validation?.messages['range_start']"
                  class="invalid-feedback"
                >
                  {{ entity?.validation?.messages["range_start"] }}
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label font-weight-bold">
                  <span
                    *ngIf="entity?.validation?.messages['range_end']"
                    class="text-danger me-2"
                  >
                    <i class="fas fa-exclamation-circle"></i>
                  </span>
                  Range End
                </label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="entity.range_end"
                  (ngModelChange)="recordChange()"
                  [class.is-invalid]="entity?.validation?.messages['range_end']"
                />
                <div
                  *ngIf="entity?.validation?.messages['range_end']"
                  class="invalid-feedback"
                >
                  {{ entity?.validation?.messages["range_end"] }}
                </div>
              </div>
            </div>

            <!-- Device Type -->
            <div class="mb-3">
              <label class="form-label font-weight-bold">
                <span
                  *ngIf="entity?.validation?.messages['device_type']"
                  class="text-danger me-2"
                >
                  <i class="fas fa-exclamation-circle"></i>
                </span>
                Device Type
              </label>
              <device-type-logical-widget
                *ngIf="device_type"
                (widgetEvent)="eventHandler($event, 'device_type')"
                [entity]="device_type"
                [options]="options"
                [layout]="'standard'"
                [class.is-invalid]="entity?.validation?.messages['device_type']"
              >
              </device-type-logical-widget>
              <div
                *ngIf="entity?.validation?.messages['device_type']"
                class="invalid-feedback d-block"
              >
                {{ entity?.validation?.messages["device_type"] }}
              </div>
            </div>

            <!-- Series -->
            <div class="mb-3">
              <label class="form-label font-weight-bold">
                <span
                  *ngIf="entity?.validation?.messages['range_series']"
                  class="text-danger me-2"
                >
                  <i class="fas fa-exclamation-circle"></i>
                </span>
                Range Series
              </label>
              <series-logical-widget
                *ngIf="series"
                (widgetEvent)="eventHandler($event, 'series')"
                [entity]="series"
                [options]="options"
                [layout]="'standard'"
                [class.is-invalid]="
                  entity?.validation?.messages['range_series']
                "
              >
              </series-logical-widget>
              <div
                *ngIf="entity?.validation?.messages['range_series']"
                class="invalid-feedback d-block"
              >
                {{ entity?.validation?.messages["range_series"] }}
              </div>
            </div>

            <!-- Manufacturer -->
            <div class="mb-3">
              <label class="form-label font-weight-bold">
                <span
                  *ngIf="entity?.validation?.messages['manufacturer']"
                  class="text-danger me-2"
                >
                  <i class="fas fa-exclamation-circle"></i>
                </span>
                Manufacturer
              </label>
              <manufacturer-logical-widget
                *ngIf="manufacturer"
                (widgetEvent)="eventHandler($event, 'manufacturer')"
                [entity]="manufacturer"
                [options]="options"
                [layout]="'standard'"
                [class.is-invalid]="
                  entity?.validation?.messages['manufacturer']
                "
              >
              </manufacturer-logical-widget>
              <div
                *ngIf="entity?.validation?.messages['manufacturer']"
                class="invalid-feedback d-block"
              >
                {{ entity?.validation?.messages["manufacturer"] }}
              </div>
            </div>

            <!-- Batch -->
            <div class="mb-3">
              <label class="form-label font-weight-bold">
                <span
                  *ngIf="entity?.validation?.messages['batch']"
                  class="text-danger me-2"
                >
                  <i class="fas fa-exclamation-circle"></i>
                </span>
                Batch
              </label>
              <batch-logical-widget
                *ngIf="batch"
                (widgetEvent)="eventHandler($event, 'batch')"
                [entity]="batch"
                [options]="options"
                [layout]="'standard'"
                [class.is-invalid]="entity?.validation?.messages['batch']"
              >
              </batch-logical-widget>
              <div
                *ngIf="entity?.validation?.messages['batch']"
                class="invalid-feedback d-block"
              >
                {{ entity?.validation?.messages["batch"] }}
              </div>
            </div>
          </div>

          <ng-template #viewMode>
            <div class="container-fluid p-3">
              <div class="row mb-3">
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-body">
                      <h5 class="card-title">Device Range Details</h5>
                      <dl class="row">
                        <dt class="col-sm-4">Identifier</dt>
                        <dd class="col-sm-8">
                          {{ entity.identifier || "new" }}
                        </dd>

                        <dt class="col-sm-4">Name</dt>
                        <dd class="col-sm-8">{{ entity.name }}</dd>

                        <dt class="col-sm-4">Description</dt>
                        <dd class="col-sm-8">{{ entity.description }}</dd>

                        <dt class="col-sm-4">Range Start</dt>
                        <dd class="col-sm-8">{{ entity.range_start }}</dd>

                        <dt class="col-sm-4">Range End</dt>
                        <dd class="col-sm-8">{{ entity.range_end }}</dd>
                      </dl>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="card">
                    <div class="card-body">
                      <h5 class="card-title">Related Information</h5>
                      <dl class="row">
                        <dt class="col-sm-4">Device Type</dt>
                        <dd class="col-sm-8">
                          <device-type-logical-widget
                            *ngIf="device_type"
                            [entity]="device_type"
                            [options]="options"
                            [layout]="'standard'"
                          >
                          </device-type-logical-widget>
                        </dd>

                        <dt class="col-sm-4">Range Series</dt>
                        <dd class="col-sm-8">
                          <series-logical-widget
                            *ngIf="series"
                            [entity]="series"
                            [options]="options"
                            [layout]="'standard'"
                          >
                          </series-logical-widget>
                        </dd>

                        <dt class="col-sm-4">Manufacturer</dt>
                        <dd class="col-sm-8">
                          <manufacturer-logical-widget
                            *ngIf="manufacturer"
                            [entity]="manufacturer"
                            [options]="options"
                            [layout]="'standard'"
                          >
                          </manufacturer-logical-widget>
                        </dd>

                        <dt class="col-sm-4">Batch</dt>
                        <dd class="col-sm-8">
                          <batch-logical-widget
                            *ngIf="batch"
                            [entity]="batch"
                            [options]="options"
                            [layout]="'standard'"
                          >
                          </batch-logical-widget>
                        </dd>
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
        <div class="device-range-widget row" *ngSwitchDefault>SIDEBAR</div>
      </ng-container>
    </ng-container>

    <ng-template #deviceTypeTemplate>
      <div
        class="modal-header d-flex justify-content-between align-items-center"
      >
        <h4 class="modal-title m-0">{{ currentModal?.title }}</h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="currentModal?.cancel()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div
        *ngIf="currentModal?.errorMsg"
        class="alert alert-danger m-2 mb-3 py-2"
      >
        {{ currentModal?.errorMsg }}
      </div>

      <!-- Not Loaded -->
      <div class="card mb-3" *ngIf="!deviceTypeEntity">
        <div
          class="card-header d-flex justify-content-start align-items-center"
        >
          <strong>Device Type:</strong> Loading
        </div>
        <div class="card-body text-center py-4">
          <widget-spinner></widget-spinner>
        </div>
      </div>

      <!-- Loaded -->
      <div class="card border-info mb-3" *ngIf="deviceTypeEntity">
        <div
          class="card-header bg-info text-white d-flex justify-content-start align-items-center"
        >
          <strong>Device Type:</strong> {{ "  " }}
          {{ deviceTypeEntity.internalName }}
        </div>

        <div class="card-body">
          <!-- Device Image -->
          <div class="row mb-4">
            <div class="col-12 text-center" *ngIf="deviceTypeEntity.image">
              <img
                [src]="deviceTypeEntity.image"
                class="img-fluid"
                style="max-height: 20vh"
                alt="{{ deviceTypeEntity.name }}"
              />
            </div>
            <div *ngIf="options?.edit" class="col-12 text-center mt-2">
              <input
                type="text"
                class="form-control form-control-sm"
                [(ngModel)]="deviceTypeEntity.image"
                (ngModelChange)="updateType(deviceTypeEntity)"
                placeholder="Image URL"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="card mb-3">
                <div
                  class="card-header bg-secondary text-white font-weight-bold"
                >
                  Details
                </div>
                <div class="card-body">
                  <!-- Definition @todo link-->
                  <div class="row mb-2">
                    <div class="col-md-3 col-4 font-weight-bold">
                      Definition:
                    </div>
                    <div class="col-md-9 col-8">
                      <a
                        routerLinkActive="active"
                        [routerLink]="[
                          '/portal/device/definitions/' +
                            deviceTypeEntity.identifier
                        ]"
                        class="text-decoration-none"
                      >
                        {{ deviceTypeEntity.identifier }}
                      </a>
                    </div>
                  </div>

                  <!-- Name -->
                  <div class="row mb-2">
                    <div
                      class="col-md-3 col-4 font-weight-bold font-weight-bold"
                    >
                      Name:
                    </div>
                    <div class="col-md-9 col-8" *ngIf="!options?.edit">
                      {{ deviceTypeEntity.name }}
                    </div>
                    <div class="col-md-9 col-8" *ngIf="options?.edit">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        [(ngModel)]="deviceTypeEntity.name"
                        (ngModelChange)="updateType(deviceTypeEntity)"
                      />
                    </div>
                  </div>

                  <!-- Internal Name -->
                  <div class="row mb-2">
                    <div
                      class="col-md-3 col-4 font-weight-bold font-weight-bold"
                    >
                      Internal:
                    </div>
                    <div class="col-md-9 col-8" *ngIf="!options?.edit">
                      {{ deviceTypeEntity.internalName }}
                    </div>
                    <div class="col-md-9 col-8" *ngIf="options?.edit">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        [(ngModel)]="deviceTypeEntity.internalName"
                        (ngModelChange)="updateType(deviceTypeEntity)"
                      />
                    </div>
                  </div>

                  <!-- Description -->
                  <div class="row mb-2">
                    <div
                      class="col-md-3 col-4 font-weight-bold font-weight-bold"
                    >
                      Description:
                    </div>
                    <div class="col-md-9 col-8" *ngIf="!options?.edit">
                      {{ deviceTypeEntity.description }}
                    </div>
                    <div class="col-md-9 col-8" *ngIf="options?.edit">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        [(ngModel)]="deviceTypeEntity.description"
                        (ngModelChange)="updateType(deviceTypeEntity)"
                      />
                    </div>
                  </div>

                  <!-- Default Series -->
                  <div class="row mb-2">
                    <div
                      class="col-md-3 col-4 font-weight-bold font-weight-bold"
                    >
                      Default Series:
                    </div>
                    <div class="col-md-9 col-8" *ngIf="!options?.edit">
                      {{ deviceTypeEntity.defaultSeries }}
                    </div>
                    <div class="col-md-9 col-8" *ngIf="options?.edit">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        [(ngModel)]="deviceTypeEntity.defaultSeries"
                        (ngModelChange)="updateType(deviceTypeEntity)"
                      />
                    </div>
                  </div>

                  <!-- Category -->
                  <div class="row">
                    <div
                      class="col-md-3 col-4 font-weight-bold font-weight-bold"
                    >
                      Device Category:
                    </div>
                    <div class="col-md-9 col-8" *ngIf="!options?.edit">
                      {{ deviceTypeEntity.category?.name }}
                    </div>
                    <div class="col-md-9 col-8" *ngIf="options?.edit">
                      <ng-select
                        *ngIf="this.category.enum"
                        class="ng-select-sm"
                        placeholder="Select Category"
                        [items]="categories"
                        bindLabel="label"
                        bindValue="value"
                        [multiple]="false"
                        handleInputChanges="true"
                        [(ngModel)]="this.category.enum"
                        (ngModelChange)="updateCategory($event)"
                      ></ng-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 mb-3">
              <embed-device-attributes
                [entity]="deviceTypeEntity"
                [layout]="'card'"
                [options]="
                  options?.attributes || { title: 'Device Type Attributes' }
                "
              ></embed-device-attributes>
            </div>
          </div>

          <!-- Field Entries -->
          <div class="card mb-3">
            <div class="card-header bg-dark text-white">
              <div class="d-flex justify-content-center">
                <b>Field Entries</b>
              </div>
            </div>

            <div class="card-body p-2">
              <div
                class="mb-3 position-relative"
                *ngFor="
                  let field of deviceTypeEntity.fieldEntries;
                  let i = index
                "
              >
                <div class="d-flex">
                  <div class="flex-grow-1">
                    <embed-device-type-field-entry
                      [entity]="field"
                      [options]="options"
                      [layout]="layout"
                    ></embed-device-type-field-entry>
                  </div>
                  <i
                    *ngIf="deviceTypeEntity.fieldEntries.length > 1"
                    class="fa fa-trash text-danger ms-2 align-self-start"
                    (click)="removeField(i)"
                    style="cursor: pointer;"
                  ></i>
                </div>
              </div>
            </div>
          </div>
          <!-- End of Field Entries -->
        </div>
      </div>

      <div class="modal-footer">
        <button
          *ngIf="currentModal?.cancelMsg"
          type="button"
          class="btn btn-outline-secondary"
          (click)="currentModal?.cancel()"
          data-dismiss="modal"
        >
          {{ currentModal?.cancelMsg }}
        </button>
        <button
          *ngIf="currentModal?.deleteMsg"
          type="button"
          class="btn btn-outline-warning"
          (click)="currentModal?.delete()"
          data-dismiss="modal"
        >
          {{ currentModal?.deleteMsg }}
        </button>
        <button
          *ngIf="currentModal?.revertMsg"
          type="button"
          class="btn btn-outline-warning"
          (click)="currentModal?.revert()"
          data-dismiss="modal"
        >
          {{ currentModal?.revertMsg }}
        </button>
        <button
          *ngIf="currentModal?.confirmMsg"
          type="button"
          class="btn btn-primary"
          (click)="currentModal?.confirm()"
        >
          {{ currentModal?.confirmMsg }}
        </button>
      </div>
    </ng-template>
  